import React, { useEffect, useState } from 'react';
import { CompositeView, Form, GridView, SimpleView, usePromise } from '@digital/ui';
import { updateUsuario, getUsuarioInfo, Usuario } from '../../api/usuario';
import PerfilForm from './PerfilForm';
import { getLoggedId } from '../../helpers';
import { getAllAreasOptions } from '@app/api/area';
import TipoOptions from '@app/helpers/tipoOptions';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllDepartamentoOptions } from '@app/api/departamento';


const Perfil = () => {
  const userId = getLoggedId();
  const [userInfo] = usePromise(
    () => (userId ? getUsuarioInfo(userId) : Promise.resolve(undefined)),
    [userId],
    {} as Usuario,
  );


  const [diretoriaOptions, setDiretoriaOptions] = useState<TipoOptions[]>();
  const [areasOptions, setAreasOptions] = useState<TipoOptions[]>();
  const [departamentoOptions, setDepartamentoOptions] = useState<TipoOptions[]>();

  useEffect(() => {
    hasGetAllDiretoriasOptions();
    hasGetAllAreasOptions();
    hasGetAllDepartamentoOptions();
  }, []);

  const hasGetAllAreasOptions = () => {
    getAllAreasOptions().then((data) => {
      setAreasOptions(data);
    });
  }

  const hasGetAllDiretoriasOptions = () => {
    getAllDiretoriasOptions().then((data) => {
      setDiretoriaOptions(data);
    });
  }

  const hasGetAllDepartamentoOptions = () => {
    getAllDepartamentoOptions().then((data) => {
      setDepartamentoOptions(data);
    });
  }

  return (
    <>
      {
        <style
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: `div.ant-breadcrumb {display: none;}`,
          }}
        />
      }
      <CompositeView>
        <SimpleView>
          <GridView noform>
            <PerfilForm
              selectedItem={userInfo}
              onUpdate={() => { }}
              diretoriaOptions={diretoriaOptions}
              areasOptions={areasOptions}
              departamentoOptions={departamentoOptions}
            />
          </GridView>
        </SimpleView>
      </CompositeView>
    </>
  );
};

export default Perfil;
